module.exports = __webpack_public_path__ + "img/uob.bce9b503.svg";